/*
 * @Description:手机验证码倒计时
 * @Version: 2.0
 * @Autor: 纪楠楠 jinannan@qfei.cn
 * @Date: 2024-09-09 18:14:11
 * @LastEditors: 纪楠楠 jinannan@qfei.cn
 */
import { ref } from 'vue';
import CONFIG from '@/config/config';
import { userService } from '@/api/user-service';
import { Message } from '@arco-design/web-vue';
export default function useCountDownTime() {
  const COUNTDOWN_SECONDS = 60; // 倒计时总时长（秒）
  const timeLeft = ref(0);
  const isCounting = ref(false); // 是否正在倒计时
  const serializeCode = ref(localStorage.getItem(CONFIG.prefix + 'serializeCode') || 0); // 临时码
  // 更新倒计时
  const updateCountdown = (key) => {
    const countdownStartTime = localStorage.getItem(CONFIG.prefix + key);
    console.log('countdownStartTime', countdownStartTime);
    if (!countdownStartTime) return;
    const now = Date.now();
    const elapsedTime = Math.floor((now - countdownStartTime) / 1000);
    if (elapsedTime < COUNTDOWN_SECONDS) {
      timeLeft.value = COUNTDOWN_SECONDS - elapsedTime;
      isCounting.value = true;
      setTimeout(() => {
        updateCountdown(key);
      }, 1000);
    } else {
      timeLeft.value = 0;
      isCounting.value = false;
      localStorage.removeItem(CONFIG.prefix + key);
    }
  };
  // 初始化倒计时
  const startCountdown = (key, phone = null, type) => {
    if (!phone) return;
    if (isCounting.value) return;
    if (phone) verifyAccount(phone, type, key);
  };
  const checkCountDownTime = (key) => {
    const countdownStartTime = localStorage.getItem(CONFIG.prefix + key);
    if (countdownStartTime) {
      updateCountdown(key);
    }
  };
  const verifyAccount = async (phone, type, key) => {
    try {
      // type 1, 登录验证码, 6, 修改密码, ,4, 初次填写手机号,5, 忘记密码找回
      const json = await userService.verifyCode({ mobile: phone, type: type });
      if (!json.error) {
        const currentTime = Date.now();
        // 倒计时
        localStorage.setItem(CONFIG.prefix + key, currentTime);
        localStorage.setItem(CONFIG.prefix + 'serializeCode', json.result?.serializeCode || 0);
        serializeCode.value = json.result?.serializeCode || 0;
        Message.success('获取验证码成功!');
        updateCountdown(key);
      } else {
        Message.error(json.error?.msg || '失败');
      }
    } catch (e) {
      Message.error(e.message || '获取失败');
    }
  };
  return {
    timeLeft,
    startCountdown,
    checkCountDownTime,
    verifyAccount,
    serializeCode
  };
}
